import React, { FC } from 'react'
import { MapMarker } from 'transfix-ui/components/MapMarker'
import { Box, createStyles, makeStyles, Typography } from 'transfix-ui/core'
import { brandColors } from 'transfix-ui/theme/colors'
import { STOP_TYPE } from 'types/shipment'
import { formatCityAndState } from 'apps/fleet-planner/utils/stops'

const useStyles = makeStyles(theme =>
  createStyles<string, { mapMarkerStyle: boolean }>({
    root: {
      width: '100%',
    },
    container: {
      paddingLeft: ({ mapMarkerStyle }) => (mapMarkerStyle ? theme.spacing(0) : theme.spacing(3)),
      marginTop: ({ mapMarkerStyle }) => (mapMarkerStyle ? theme.spacing(0) : theme.spacing(-4)),
      color: brandColors.coolGray6,
    },
    text: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    textSecondaryColor: {
      color: brandColors.coolGray5,
    },
    textTertiaryColor: {
      color: brandColors.coolGray8,
    },
  })
)

interface ILaneOffersMobileInformationProps {
  city?: string
  stateCode?: string
  mapMarkerType?: 'pickup' | 'delivery'
  subtitle?: string
}

export const LaneOffersMobileInformation: FC<ILaneOffersMobileInformationProps> = ({
  city = '',
  mapMarkerType,
  stateCode = '',
  subtitle = '',
}) => {
  const classes = useStyles({ mapMarkerStyle: mapMarkerType === undefined })
  const sequence = mapMarkerType === 'pickup' ? 0 : 1

  return (
    <Box className={classes.root}>
      {mapMarkerType && <MapMarker type={mapMarkerType as STOP_TYPE} sequence={sequence} mini />}
      <Box className={classes.container} paddingLeft={2}>
        <Typography variant='subtitle1'>
          <div className={classes.text}>{formatCityAndState(city, stateCode)}</div>
        </Typography>
        {subtitle && (
          <Typography component='div' variant='body2'>
            <div className={classes.text}>{subtitle}</div>
          </Typography>
        )}
      </Box>
    </Box>
  )
}
